export const NODE_ENV = process.env.NODE_ENV
export const CLOUD9_API = NODE_ENV !== 'development' ? process.env.REACT_APP_API_URL || 'https://api.gain-intel.com' : 'https://api.gain-intel.com';
//export const CLOUD9_API = 'http://localhost:9900'
export const MESSAGING = process.env.REACT_APP_MESSAGING_URL || 'https://api.gain-intel.com/messaging'
export const ORDERING_WS = `${CLOUD9_API}/orders`.replace(/^http/, 'ws')

// Deploy target ('production' | 'staging'), injected at build time. CRA builds
// both staging and production with NODE_ENV='production', so this is how the
// app tells them apart. Defaults to 'staging' when unset (e.g. local builds).
export const DEPLOY_TARGET = process.env.REACT_APP_DEPLOY_TARGET || 'staging'
// export const CLOUD9_API = NODE_ENV !== 'development' ? 'https://api.gain-intel.com/api' : 'https://api.gain-intel.com/api'
